<template>
    <div class="wrapper news_headlines_wrapper">
        <div class="news_headlines_container">
            <div class="news_headlines_label_container"><span>Latest</span> <span class="highlight">News Headlines</span></div>
            <div class="news_headlines_content_container">
                <div class="news_headlines_content">
                    <ul>
                        <li v-for="news_headline in news_headlines" v-html="news_headline"></li>
                    </ul>
                </div>
                <div class="news_headlines_content news_headlines_content_clone" v-for="i in clone_count" v-html="clone_html"></div>
            </div>
        </div>
        <component is="style" v-html="component_style"></component>
    </div>
</template>

<script>
    export default {
        name: "NewsHeadlines",
        props: ['option'],
        data() {
            let option = this.option;

            let data_set = {
                news_headlines: this.$root.news_headlines,
                content_width: 100,
                clone_html: '',
                scrolling_speed: 50,
                component_style: '',
                clone_count: 0,
            };
            let current_object = this;
            if (current_object.option) {
                Object.keys(current_object.option).forEach(function (option_key) {
                    data_set[option_key] = current_object.option[option_key];
                });
            }
            return data_set;
        } ,
        mounted() {
            let current_object = this;
            let scrolling_text_container = $(current_object.$el).find('.news_headlines_content_container');
            let scrolling_text_content = scrolling_text_container.find('.news_headlines_content');
            current_object.content_width = scrolling_text_content.outerWidth();
            current_object.clone_html = scrolling_text_content.html();
            // Guard against the empty-headlines case: if no headlines
            // are present the content width is 0, dividing by it yields
            // Infinity, and `v-for="i in Infinity"` throws "Invalid
            // array length" — surfacing in the console as a runtime Vue
            // render error on every page load. Clamp to a sane upper
            // bound and zero-out when there's nothing to scroll.
            if (! current_object.content_width || current_object.content_width < 1) {
                current_object.clone_count = 0;
            } else {
                current_object.clone_count = Math.min(
                    20,
                    Math.max(0, Math.ceil(scrolling_text_container.width() / current_object.content_width)),
                );
            }
            let loop_circle = Math.round(current_object.content_width/current_object.scrolling_speed);
            let style_text = '@keyframes newsrolling {';
            style_text += '\n' + '  0%      {margin-left:0;}';
            style_text += '\n' + '  99.99%  {margin-left:-'+current_object.content_width+'px;}';
            style_text += '\n' + '  100%    {margin-left:0;}';
            style_text += '\n' + '}';
            style_text += '\n' + '.news_headlines_container .news_headlines_content_container .news_headlines_content {animation: newsrolling '+loop_circle+'s linear infinite;}';

            current_object.component_style = style_text;
        }
    }
</script>